import { createRouter, createWebHistory } from 'vue-router'
import requireAuth from './requireAuth'
import redirectIfAuth from './redirectIfAuth'

const routes = [
  {
    path: '/',
    name: 'loginView',
    meta: { layout: 'login-layout' },
    component: () => import('../views/LoginView.vue'),
    beforeEnter: redirectIfAuth
  },
  {
    path: '/home',
    name: 'homeView',
    meta: { layout: 'standart-layout' },
    component: () => import('../views/HomeView.vue'),
    beforeEnter: requireAuth
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
